
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getInspirationCategory } from '../../service/category-service';

// Initial state definition
const initialState = {
    categoryList: [],
    isLoading: false,
    error: ""
};

// Async thunk to fetch candidates
export const getInspirationCategorydata = createAsyncThunk(
    'inspirationCategorySlice/list',
    async () => {

        const response = await getInspirationCategory();
        return response?.data;
    }
);




// Slice definition
export const inspirationCategorySlice = createSlice({
    name: 'inspirationCategorySlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getInspirationCategorydata.pending, (state) => {
                state.isLoading = true;
            })

            .addCase(getInspirationCategorydata.fulfilled, (state, action) => {
                const { result } = action.payload
                state.categoryList = result
                state.isLoading = false
                state.error = ""
            })
            .addCase(getInspirationCategorydata.rejected, (state, action) => {
                state.categoryList = [];
                state.isLoading = false;
                state.error = action.payload.error;
            })
    },
});

export default inspirationCategorySlice.reducer;
